export default Object.freeze({
	DEFAULT_BROKER_ID: 'icarewc',
	DEFAULT_BROKER_ORG: 'icare',
	DEFAULT_BRANCH: 'icare',
});
